export const getResponseErrorMessage = (err: unknown) => {
  if (
    err !== null &&
    typeof err === 'object' &&
    'message' in err &&
    typeof err.message === 'string'
  ) {
    return err.message;
  } if (
    err !== null &&
    typeof err === 'object' &&
    'details' in err &&
    typeof err.details === 'string'
  ) {
    return err.details;
  }

  return typeof err === 'string' ? err : JSON.stringify(err);
};
